import { TrackingHandler } from '../../tracking/TrackingHandler';
import { getRecaptchaToken } from '../../helpers/captchas';
import { getUrlParameter } from '../../helpers/browser';
import { resolveSubmitId, resolveViewTime } from './form-state';
export const trimFormDataFields = (data) => {
    Object.keys(data).forEach((key) => {
        if (key === 'password') {
            return;
        }
        const value = data[key];
        if (typeof value === 'string') {
            data[key] = value.trim();
        }
    });
    return data;
};
export const addTrackingData = (data) => {
    const trackingData = TrackingHandler.getInstance().getAllTrackingData();
    data.view_id_c = trackingData.viewId;
    data.visit_id_c = trackingData.visitId;
    data.visitor_id_c = trackingData.visitorId;
    data.vtuid_c = trackingData.visitorId;
    data.origin_source_c = trackingData.source;
    data.origin_medium_c = trackingData.medium;
    data.origin_campaign_c = trackingData.campaign;
    data.origin_details_c = JSON.stringify(trackingData.originDetails);
    data.page_url_c = trackingData.currentUrl;
    data.referral_code_c = trackingData.referralCode;
    data.fingerprint_c = trackingData.fingerprint;
    if (typeof data.product_c !== 'string' || data.product_c.length === 0) {
        data.product_c = trackingData.pageProduct;
    }
    if (typeof window.prices !== 'undefined' && typeof window.prices.startCredits === 'number') {
        data.customer_conditions_c = 'Start credits: ' + window.prices.startCredits.toString() + ' €';
    }
    return data;
};
export const prepareStandardSubmission = async (state, data) => {
    data.form_name_c = state.formName;
    data.submit_id_c = resolveSubmitId(state);
    data.vt = resolveViewTime(state);
    data.rct = await getRecaptchaToken();
    return addTrackingData(data);
};
export const getSubmissionHeaders = (alternateOrigin = null) => {
    const headers = {};
    if (alternateOrigin) {
        headers['x-alternate-origin'] = alternateOrigin;
    }
    const bypassCaptchaCode = getUrlParameter('bypass-captcha');
    if (bypassCaptchaCode) {
        headers['x-bypass-captcha'] = bypassCaptchaCode;
    }
    return headers;
};
export const postJson = (url, data, headers = {}) => {
    const xhr = new XMLHttpRequest();
    xhr.open('POST', url);
    xhr.responseType = 'json';
    xhr.setRequestHeader('Accept', 'application/json');
    xhr.setRequestHeader('Content-Type', 'application/json');
    Object.entries(headers).forEach(([name, value]) => xhr.setRequestHeader(name, value));
    return new Promise((resolve) => {
        xhr.onreadystatechange = () => {
            if (xhr.readyState === XMLHttpRequest.DONE) {
                resolve({
                    status: xhr.status,
                    body: xhr.response,
                });
            }
        };
        xhr.send(JSON.stringify(data));
    });
};
